import { BlocklyWorkSpaceType } from '../@types/BlocklyWorkspaceType';

export class BloclyDispatcher {
  /**
   * イベントのディクショナリ
   */
  events: { [eventName: string]: ((e: any) => void)[] } = {};

  /**
   * イベントリスナーの追加
   * @param name
   * @param handler
   */
  private addEventListener(name: string, handler: (event: BlocklyWorkSpaceType) => void) {
    if (!this.events[name]) {
      this.events[name] = [];
    }
    this.events[name].push(handler);
  }
  /**
   * イベントの起動
   * @param name
   * @param param 引数
   */
  triggerEvent(name: string, param: any = {}): void {
    if (!this.events[name]) return;
    this.events[name].forEach((event) => event(param));

    // イベントキャッシュをクリア
    this.events[name] = [];
  }

  /**
   * ブロックを作った時に発動するイベント
   * @param handler
   */
  loadProjectKey = 'TRIGGER_LOAD_PROJECT';
  addLoadProjectKeyListener(handler: (project: any) => void): void {
    this.addEventListener(this.loadProjectKey, handler);
  }

  triggerLoadProject(project: any): void {
    this.triggerEvent(this.loadProjectKey, project);
  }

  /**
   * ブロックを作った時に発動するイベント
   * @param handler
   */
  createBlockKey = 'TRIGGRE_CREATE_BLOCK';
  addCreateBlockListener(handler: (workspace: any) => void): void {
    this.addEventListener(this.createBlockKey, handler);
  }
  triggerCreateBlock(workspace: BlocklyWorkSpaceType): void {
    this.triggerEvent(this.createBlockKey, workspace);
  }

  /**
   * ツールボックスを更新した時に発動するイベント
   * @param handler
   */
  updateToolboxKey = 'TRIGGER_UPDATE_TOOLBOX';
  addUpdateToolboxListener(handler: (workspace: BlocklyWorkSpaceType) => void): void {
    this.addEventListener(this.updateToolboxKey, handler);
  }
  triggerUpdateToolbox(workspace: BlocklyWorkSpaceType): void {
    this.triggerEvent(this.updateToolboxKey, workspace);
  }

  /**
   * ワークスペースを切り替えた時に発動するイベント
   * @param handler
   */
  switchWorkspaceKey = 'TRIGGER_SWITCH_WORKSPACE';
  addSwitchWorkspaceListener(handler: (workspace: BlocklyWorkSpaceType) => void) {
    this.addEventListener(this.switchWorkspaceKey, handler);
  }
  triggerSwitchWorkspace(workspace: BlocklyWorkSpaceType) {
    this.triggerEvent(this.switchWorkspaceKey, workspace);
  }

  /**
   * ワークスペースを変更した時に発動するイベント
   * @param handler
   */
  eventOnWorkspaceKey = 'TRIGGER_EVENT_ON_WORKSPACE';
  addEventOnWorkspaceListener(handler: (workspace: BlocklyWorkSpaceType) => void) {
    this.addEventListener(this.eventOnWorkspaceKey, handler);
  }
  triggerEventOnWorkspace(workspace: BlocklyWorkSpaceType) {
    this.triggerEvent(this.eventOnWorkspaceKey, workspace);
  }

  /**
   * ワークスペースを変更した時に発動するイベント
   * @param handler
   */
  changeWorkSpaceKey = 'TRIGGER_CHANGE_WORKSPACE_XML';
  addChangeWorkSpaceListener(handler: (workspace: BlocklyWorkSpaceType) => void) {
    this.addEventListener(this.changeWorkSpaceKey, handler);
  }
  triggerChangeWorkSpace(workspace: BlocklyWorkSpaceType) {
    this.triggerEvent(this.changeWorkSpaceKey, workspace);
  }

  /**
   * ワークスペースをマウントした時に発動するイベント
   * @param handler
   */
  mountedWorkspaceKey = 'TRIGGER_MOUNTED_WORKSPACE';
  addMountedWorkspaceListener(handler: (workspace: BlocklyWorkSpaceType) => void) {
    this.addEventListener(this.mountedWorkspaceKey, handler);
  }
  triggerMountedWorkspace(workspace: BlocklyWorkSpaceType) {
    this.triggerEvent(this.mountedWorkspaceKey, workspace);
  }
}

export const blocklyDispatcher = new BloclyDispatcher();
